import { createProcessEvents } from '@pass-frontend/utility/event-bus';

export interface LWRRequest {
  cookieNames?: string;
  path: string;
}

export const HUGINN_LOAD = createProcessEvents<void, void, Error>(
  'huginn/load',
);
export const LWR_AUTH = createProcessEvents<
  LWRRequest,
  Record<string, string>,
  Record<string, any> | void
>('LWR');

// Possible values of #message of an error in a GQL response
export const SESSION_UNAUTHENTICATED = 'Session unauthenticated';
export const SESSION_UNAUTHORIZED = 'Session unauthorized';
